var _defs, _g, _path, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8f347d2b02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 3.945312 L 28 3.945312 L 28 8 L 2 8 Z M 2 3.945312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a23531b52c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2 21 L 28 21 L 28 24.992188 L 2 24.992188 Z M 2 21 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f347d2b02)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e0d3",
    d: "M 19.316406 4.035156 C 15.421875 4.089844 4.769531 4.308594 3.355469 4.519531 C 1.917969 4.730469 2.402344 6.808594 3.679688 6.90625 C 6.625 7.132812 26.941406 7.152344 26.011719 7.152344 C 28.058594 7.152344 28.0625 3.984375 26.011719 3.984375 C 26.902344 3.984375 20.902344 4.011719 19.316406 4.035156 Z M 19.316406 4.035156 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9e0d3",
    d: "M 19.316406 12.917969 C 15.421875 12.972656 4.769531 13.191406 3.355469 13.398438 C 1.917969 13.613281 2.402344 15.6875 3.679688 15.785156 C 6.625 16.011719 26.941406 16.035156 26.011719 16.035156 C 28.058594 16.035156 28.0625 12.867188 26.011719 12.867188 C 26.902344 12.867188 20.902344 12.894531 19.316406 12.917969 Z M 19.316406 12.917969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a23531b52c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e9e0d3",
    d: "M 19.316406 21.800781 C 15.421875 21.855469 4.769531 22.070312 3.355469 22.28125 C 1.917969 22.492188 2.402344 24.570312 3.679688 24.667969 C 6.625 24.894531 26.941406 24.914062 26.011719 24.914062 C 28.058594 24.914062 28.0625 21.75 26.011719 21.75 C 26.902344 21.75 20.902344 21.777344 19.316406 21.800781 Z M 19.316406 21.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.5673a99eefb381fc75deaa77bb10d132.svg";
export { ForwardRef as ReactComponent };